require("../vendor/tarteaucitron/tarteaucitron.js");

const getRoomData = () => {
  const el = document.querySelector('#tomo-init') || document.body;
  return {
    roomId: el.dataset.roomId,
    roomName: el.dataset.roomName
  };
};

const initTarteAuCitron = () => {
  if (!window.tarteaucitron) return;
  window.tarteaucitronCustomText = {
    "alertBigPrivacy": "Ce site utilise des 🍪 et vous donne le contrôle sur ce que vous souhaitez activer",
    "tarteaucitronPersonalize": "ok",
    "mandatoryText": "Ce site utilise un cookie nécessaire à son bon fonctionnement (_tomo_session). Il ne peut pas être désactivé."
  };

  tarteaucitron.init({
    "hashtag": "#tarteaucitron",
    "cookieName": "tarteaucitron",
    "removeCredit": true,
    privacyUrl: "/politique_de_confidentialite",
    orientation: "middle",
    showAlertSmall: false,
    cookieslist: true,
    adblocker: false,
    highPrivacy: true,
    "handleBrowserDNTRequest": false,
    "useExternalCss": true,
    "moreInfoLink": true,
    "readmoreLink": "politique_de_confidentialite",
    lang: "fr",
    "mandatory": true
  });

  const { roomId, roomName } = getRoomData();

  // Ex Ruby: if @room.present? && @room.id != 1 && @room.name != "Reco Doc"
  if (roomId && roomId !== "1" && roomName !== "Reco Doc") {
    tarteaucitron.user.piwikProId = 'e5cb782c-887a-40e9-a146-ab35b056e2a9';
    (tarteaucitron.job = tarteaucitron.job || []).push('piwikpro');
  }
};

export { initTarteAuCitron };